import React from 'react'
import { Oval } from "react-loader-spinner";

const Loader = () => {
    return (
        <>
            <Oval
                height={60}
                width={60}
                color="#00a1b1"
                wrapperClass="loader-wrapper"
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#00a1b1"
                strokeWidth={2}
                strokeWidthSecondary={2}
            />
        </>
    )
}

export default Loader